module.exports = __webpack_public_path__ + "static/media/linkedin-azul.7884a54e.svg";